module.exports = __webpack_public_path__ + "img/noDataCoolDark.e9c240f6.png";